
























// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import TheFormCoupons from '@/components/coupons/TheFormCoupons.vue';
// Importing functions
import {validateCoupons} from '@/ts/coupons/validate-coupons';
import {postCoupons} from '@/ts/coupons/post-coupons';

export default {
    name: 'PageUsersUpdate',
    components: {
        TheFormCoupons,
        LayoutApp,
        BaseCard,
    },
    props: {},
    data() {
        return {
            data: {},
            errors: [],
            items: [],
        };
    },
    methods: {
        onSubmit() {
            this.errors = [];

            validateCoupons(this.errors, this.data);

            if (this.errors.length === 0) {
                this.data.expiration = this.data.expiration.replace('T', ' ').replace('.000Z', '');

                postCoupons(this.data, this.$route.params.id).then(() => {
                    this.$router.push({ name: 'coupons', params: { id: this.$route.params.id } });
                }).catch(() => {
                    this.data.expiration.replace(' ', 'T');
                    this.data.expiration = this.data.expiration + 'Z';
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Промокодове',
            to: { name: 'coupons', params: { id: this.$route.params.id} },
        }, {
            text: 'Създаване',
        }];
        // Initializing the user data object
        this.data = {
            total_coupons: '',
            discount: '',
            min_order: '',
            expiration: '',
        };
    },
};
